import { render, staticRenderFns } from "./FacSearch.vue?vue&type=template&id=6781e8ba"
import script from "./FacSearch.vue?vue&type=script&lang=js"
export * from "./FacSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports